<template>
  <Layout>
    <ModalCancelPurchase />
    <Title
      title="Compras"
      v-if="titleIsLoaded"
      :hasPrint="true"
      :hasNewRegister="true"
      :routeNewRegister="handleNavigationRegister"
      :newRegisterButtonName="'Nova Compra'"
      :disableNewButton="issuerBasicData.isEmpty"
      :reasonsToDisableNewButton="issuerBasicData.requiredData"
    />
    <Table
      class="table-hover"
      :key="tableKey"
      :tableData="tableData"
      :items="summaryPurchases"
      :pagination="true"
      :perPage="paginationPurchase.perPage"
      :startItem="paginationPurchase.startItem"
      :endItem="paginationPurchase.endItem"
      :totalItems="paginationPurchase.totalItems"
      :page="paginationPurchase.currentPage"
      :onClickRow="handleNavigationEdit"
      :onSearch="search"
      @changeItemsPerPage="handleChangeItemsPerPage"
      @changePage="handleChangePage"
    >
    </Table>
  </Layout>
</template>

<script>
import { Layout, Title, Table, TableData, Actions } from '@/components';
import { mapState, mapActions } from 'vuex';
import ModalCancelPurchase from '../components/Modals/ModalCancelPurchase/ModalCancelPurchase.vue';

export default {
  name: 'purchase',
  components: {
    Layout,
    Title,
    Table,
    ModalCancelPurchase,
  },
  async mounted() {
    await this.setClient();
    await this.emptyIssuerBasicData();
    await this.resetPurchase();
    await this.setPurchase();

    try {
      await this.setLoading(true);
      await this.setSummaryPurchases({
        search: null,
        pagination: this.paginationPurchase,
      });
      await this.setLoading(false);
    } catch {
      this.setLoading(false);
    }

    this.titleIsLoaded = true;
  },
  computed: {
    ...mapState('purchase', ['summaryPurchases', 'paginationPurchase']),
    ...mapState('componentsPurchase', ['modalCancelPurchaseIsOpen']),
    ...mapState('client', ['client']),
    optionsStatus() {
      return [{ value: 'todos', text: 'Todos' }];
    },
    tableData() {
      const { Data, TABLE_CELL_ALIGN } = TableData;

      const DataTable = new Data({
        select: true,
        panelActions: true,
        advancedFilters: true,
        onSearch: this.search,
        titleMobile: (item) => item.description,
      });

      DataTable.addField({
        key: 'entryDate',
        label: 'Data',
        sortable: true,
        align: TABLE_CELL_ALIGN.center,
        formatter: (value) => this.$moment(value).format('DD/MM/YYYY'),
        width: 100,
      })
        .addField({
          key: 'nfeNumber',
          label: 'Número',
          sortable: true,
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'supplier',
          label: 'Fornecedor',
          sortable: true,
          width: 600,
          align: TABLE_CELL_ALIGN.left,
        })
        .addField({
          key: 'vNF',
          label: 'Total R$',
          sortable: true,
          width: 150,
          formatter: (value) =>
            new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }).format(value),
          align: TABLE_CELL_ALIGN.right,
        })
        .addActions(Actions('cancel', (selected) => this.cancel(selected)));
      return DataTable;
    },
  },
  data() {
    return {
      titleIsLoaded: false,
      issuerBasicData: {
        isEmpty: false,
        requiredData: ['Endereço', 'CPF/CNPJ'],
      },
      tableKey: 0,
      form: {
        date: this.$moment(this.$moment().format('YYYY-MM-01')).toDate(),
        search: '',
        status: 'todos',
      },
    };
  },
  methods: {
    ...mapActions('purchase', [
      'resetPurchase',
      'searchPurchases',
      'setPurchase',
      'setSummaryPurchases',
      'setDetailedPurchase',
    ]),
    ...mapActions('application', ['setLoading']),
    ...mapActions('client', ['setClient']),
    ...mapActions('componentsPurchase', [
      'toggleModalCancelPurchase',
      'setModalCancelPurchaseIds',
    ]),
    emptyIssuerBasicData() {
      if (
        !this.client.addressCollection.length ||
        !this.client.identification
      ) {
        this.issuerBasicData.isEmpty = true;
      }
    },
    async search(value) {
      await this.setLoading(true);
      await this.setSummaryPurchases({
        search: value,
        pagination: { ...this.paginationPurchase, currentPage: 1 },
      });
      await this.setLoading(false);
    },
    async handleChangeItemsPerPage(items) {
      const pagination = {
        ...this.paginationPurchase,
        perPage: items,
        currentPage: 1,
      };
      await this.setLoading(true);
      await this.setSummaryPurchases({ search: null, pagination });
      await this.setLoading(false);
    },
    async handleChangePage(page) {
      const pagination = { ...this.paginationPurchase, currentPage: page };
      await this.setLoading(true);
      await this.setSummaryPurchases({
        search: null,
        pagination,
      });
      await this.setLoading(false);
    },
    async handleNavigationEdit(item) {
      if (!item.id) return null;

      return this.$router.push({
        name: 'PurchaseEdit',
        params: { id: item.id },
      });
    },
    async handleNavigationRegister() {
      return this.$router.push({ name: 'PurchaseRegister' });
    },
    cancel(selected) {
      this.setModalCancelPurchaseIds(selected);
      this.toggleModalCancelPurchase();
    },
  },
  watch: {
    modalCancelPurchaseIsOpen() {
      if (!this.modalCancelPurchaseIsOpen) {
        this.tableKey += 1;
      }
    },
  },
};
</script>
